



















































































































import {Component} from 'vue-property-decorator'
import {Getter} from "vuex-class";
import {LongTextWings, ScrollButton} from 'wings-ui-components';
import SmsDetailFilter from '@/components/SMS/SmsDetailFilter.vue';
import {dateFilter} from "@/utils/date-util";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import { DetailItem } from "@/store/sms/statistic/types";

@Component({ components: {SmsDetailFilter, ScrollButton, LongTextWings}, filters: {dateFilter} })
export default class SmsDetail extends BaseItemsPage<DetailItem> {

  @Getter("smsStatisticDetail") responseItems: any;

  is_show_filter_additional = false;
  currentSort = "create_date";

  tableFields = this.tableFieldsDefault;

  get tableFieldsDefault() {
    return [
      "create_date",
      "originator",
      "recipient",
      "message",
      "status",
      "message_parts",
      "partner_price",
      "detail"
    ];
  }

  getData() {
    return this.responseItems;
  }

}
